function normalizePermArray(raw) {
  if (!Array.isArray(raw)) return [];
  return raw.map((p) => String(p).trim()).filter(Boolean);
}

/** Normalize API / stored user so role checks are reliable. */
export function normalizeAuthUser(user) {
  if (!user || typeof user !== 'object') return user;
  const out = { ...user };
  if (out.role_slug != null && out.role_slug !== '') {
    out.role_slug = String(out.role_slug).toLowerCase().trim();
  }
  out.effective_permissions = normalizePermArray(out.effective_permissions);
  out.extra_permissions = normalizePermArray(out.extra_permissions);
  out.role_permissions = normalizePermArray(out.role_permissions);
  out.can_have_extra = !!out.can_have_extra;
  if (user.whatsapp_config && typeof user.whatsapp_config === 'object') {
    out.whatsapp_config = { ...user.whatsapp_config };
  }
  if (Array.isArray(user.available_branches)) {
    out.available_branches = user.available_branches;
  }
  if (user.active_branch_id != null && user.active_branch_id !== '') {
    out.active_branch_id = Number(user.active_branch_id);
  } else {
    out.active_branch_id = null;
  }
  out.active_branch_name = user.active_branch_name ?? null;
  if (user.school_observer_mode != null) {
    out.school_observer_mode = !!user.school_observer_mode;
  } else {
    out.school_observer_mode = false;
  }
  if (user.observer_school_name != null) {
    out.observer_school_name = String(user.observer_school_name);
  } else {
    out.observer_school_name = null;
  }
  return out;
}
